import React from 'react';
import MobileApplication from '../../../components/mobile-application';
import SimpleMobilePageNavbar from '../../../components/mobile-navbar/simple-mobile-page-navbar';
import {logout} from '../../../actions/validateSession';
import {MobileHighSchoolOnboarding} from './index';
import {MobileApplicationLoaderProps} from '../../../components/mobile-application/mobile-application';

export default function HighSchoolMobileOnboarding({store}: MobileApplicationLoaderProps) {
  return (
    <MobileApplication
      navbar={
        <SimpleMobilePageNavbar
          title=""
          button={{
            onClick: logout,
            text: 'Log Out',
          }}
        />
      }
      routes={[{path: '*', component: MobileHighSchoolOnboarding}]}
      store={store}
      animated={false}
      disableToolbarNotification
    />
  );
}
